import React from 'react'

function IssuedBook() {
  return (
    <div>IssuedBook</div>
  )
}

export default IssuedBook